import { CuisineOption } from "@/clients/models/CuisineOption";
import { FavoriteCuisines } from "@/clients/models/FavoriteCuisines";
import { QueryKeys } from "@/constants/query-keys";
import { useGetFavoriteCuisines } from "@/hooks/requests/favorite-cuisines/use-get-favorite-cuisines";
import { useUpdateFavoriteCuisines } from "@/hooks/requests/favorite-cuisines/use-update-favorite-cuisines";
import { useToast } from "@/hooks/ui/use-toast";
import { setProfileContext } from "@/utils/sentry/tools";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";

interface Cuisine {
  name: string;
  value: CuisineOption;
}

const defaultCuisineList = [
  { name: "Italian", value: CuisineOption.ITALIAN },
  { name: "Chinese", value: CuisineOption.CHINESE },
  { name: "Indian", value: CuisineOption.INDIAN },
  // { name: "Japanese", value: CuisineOption.JAPANESE },
  { name: "Mexican", value: CuisineOption.MEXICAN },
  // { name: "Mediterranean", value: CuisineOption.MEDITERRANEAN },
  // { name: "American", value: CuisineOption.AMERICAN },
  // { name: "Korean", value: CuisineOption.KOREAN },
  { name: "Middle Eastern", value: CuisineOption.MIDDLE_EASTERN },
  // { name: "French", value: CuisineOption.FRENCH },
  // { name: "Vietnamese", value: CuisineOption.VIETNAMESE },
  { name: "Pan Asian", value: CuisineOption.PAN_ASIAN },
];

export const useFavoriteCuisines = (onSuccess: () => void) => {
  const { showError } = useToast();
  const [cuisineList] = useState<Cuisine[]>(defaultCuisineList);
  const queryClient = useQueryClient();
  const { favoriteCuisines, isLoading: isFavoriteCuisinesLoading } =
    useGetFavoriteCuisines();
  const { updateFavoriteCuisines, isUpdating } = useUpdateFavoriteCuisines();
  const [selectedCuisines, setSelectedCuisines] = useState<Set<CuisineOption>>(
    new Set(),
  );

  useEffect(() => {
    if (favoriteCuisines) {
      setSelectedCuisines(new Set(favoriteCuisines.cuisineOptions ?? []));
    }
  }, [favoriteCuisines]);

  const handleSubmit = () => {
    const dataBody: FavoriteCuisines = {
      cuisineOptions: Array.from(selectedCuisines),
    };
    updateFavoriteCuisines(dataBody, {
      onSuccess: () => {
        queryClient.setQueryData([QueryKeys.FAVORITE_CUISINES], dataBody);
        setProfileContext(QueryKeys.FAVORITE_CUISINES, dataBody);
        onSuccess();
      },
      onError: (error) => {
        showError(error.message);
      },
    });
  };
  return {
    cuisineList,
    selectedCuisines,
    setSelectedCuisines,
    handleSubmit,
    isUpdating,
    isFavoriteCuisinesLoading,
  };
};
